<template>
  <div id="loginWrap">
      <h1 @click="showDeviceUuid()"></h1>

      <input type="text" 
        maxlength="18"
        ref="userId" 
        v-model.trim="userId" 
        @keydown.enter="login"
        placeholder="아이디">
      <input type="password" 
        ref="password" 
        v-model.trim="password" 
        @keydown.enter="login"
        placeholder="비밀번호">

      <span class="checkbox">
          <input type="checkbox"
            id="idSave"
            v-model="idSave"
            true-value="Y"
            false-value="N">
          <label for="idSave">아이디 저장</label>
      </span>
      <span class="checkbox">
          <input type="checkbox" 
          id="autoLogin" 
          v-model="autoLogin"
          true-value="Y"
          false-value="N">
          <label for="autoLogin">자동 로그인</label>
      </span>

      <button type="button" class="login" v-on:click="login()">로그인</button>
      <p><button type="button" @click="goOtherSite('https://ksos.kyowon.co.kr/pwChange')">비밀번호를 잊으셨나요?</button></p>
  </div>
</template>
<script>
// import axios from 'axios'

export default {
  name: "Login",
  data() {
    return {
      userId: "",
      password: "",
      idSave: "N",
      autoLogin: "Y"
    };
  },
  watch: {
    '$store.state.ui.child': function() {
      var childName = this.$store.state.ui.child.name;
      if(childName == 'native-onloaded') {
          if (this.userId == "") {
            this.$refs.userId.focus();
          } else {
            this.$refs.password.focus();
          }
      }
    }
  },
  methods: {
    params() {
      return {
        userId: this.userId,
        password: this.password,
        pushToken: decodeURIComponent(this.$utils.nativeCom.getUserAgentValue("pushToken")),
        autoLoginYn: this.autoLogin
      };
    },
    validate() {
      if (this.userId == "") {
        alert("아이디를 입력해주세요.");
        this.$refs.userId.focus();
        return false;
      }

      if (this.password == "") {
        alert("비밀번호를  입력해주세요.");
        this.$refs.password.focus();
        return false;
      }
      return true;
    },
    login() {
      var validate = this.validate();
      if(!validate) {
        return;
      }

      var that = this;
      var params = this.params();
      this.$api.auth
        .login(params)
        .then(function(user) {
          console.log("Login.vue <api.auth.login.response>", user);
          that.saveSession(user);
          that.saveUi();
          that.$router.push({ name: "main" }).catch(function() {});
        })
        .catch(function(error) {
          alert(error.rtMsg);
          that.password = '';
        });
    },
    saveSession(user) {
      this.$store.commit("SET_USER", user);
      this.$utils.nativeIf.outbound.setAppDB("authToken", user.authToken);
    },
    saveUi() {
      var userId = this.userId;
      if(this.idSave != 'Y') {
        userId = '';
      }
      var login = {
        idSave: this.idSave,
        userId: userId
      }
      this.$store.commit("SET_UI_LOGIN", login);
    },
    goOtherSite(url){
      this.$utils.nativeIf.outbound.outlink(url)        
    },
    showDeviceUuid() {
      var deviceUuid = this.$utils.nativeCom.getDevideUuid();
      alert(deviceUuid);
    }
  },
  beforeCreate: function() {
  },
  created () {
      // this.chkWorkNotice();
  },
  updated: function() {
      // this.chkWorkNotice();
  },
  beforeMount: function() {
  },
  mounted: function() {
    var login = this.$store.getters.ui.login;
    this.idSave = login.idSave;
    this.userId = login.userId;

    // var child = {
    //     name: 'native-onloaded',
    //     data: {
    //     }
    // }
    // this.$store.commit("SET_UI_CHILD", child);
  },
  beforeUpdate: function() {
  },
  beforeDestroyed: function() {
  },
  destroyed: function() {
  }
};
</script>